import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const Success = () => {
  return (
    <div>
      <div className="sent-message">Your email has been sent successfully.</div>
    </div>
  );
};

const Error = () => {
  return (
    <div>
      <div className="error-message">Your email has not been sent. Please try again.</div>
    </div>
  );
};

function Contact() {
  const [result, showResult] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();
    showResult('sending');

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(
        (result) => {
          console.log(result.text);
          showResult('success');
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
          showResult('error');
        }
      );

    setTimeout(() => {
      showResult(null);
    }, 5000);
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-title">
          <h2>Contact</h2>
          <p>Get In Touch</p>
        </div>

        <div className="row mt-2">
          <div className="col-md-6 d-flex align-items-stretch">
            <div className="info-box">
              <i className="bx bx-map"></i>
              <h3>My Address</h3>
              <p>42. S.H Road, Meerakerny, Eravur, Batticaloa 30300, Sri Lanka</p>
            </div>
          </div>

          <div className="col-md-6 mt-4 mt-md-0 d-flex align-items-stretch">
            <div className="info-box">
              <i className="bx bx-share-alt"></i>
              <h3>Social Profiles</h3>
              <div className="social-links">
                <a href="https://www.facebook.com/mohamed.awsath.7/" target="_blank" rel="noreferrer" className="facebook"><i className="ri-facebook-circle-fill" style={{ fontSize: "22px" }}></i></a>
                <a href="https://instagram.com/awshath" target="_blank" rel="noreferrer" className="instagram"><i className="ri-instagram-line" style={{ fontSize: "22px" }}></i></a>
                <a href="https://www.linkedin.com/in/mohamed-awshad-055209178" target="_blank" rel="noreferrer" className="linkedin"><i className="ri-linkedin-box-fill" style={{ fontSize: "22px" }}></i></a>
                <a href="https://github.com/Awshad" target="_blank" rel="noreferrer" className="github"><i className="ri-github-fill" style={{ fontSize: "22px" }}></i></a>
              </div>
            </div>
          </div>

          <div className="col-md-6 mt-4 d-flex align-items-stretch">
            <div className="info-box">
              <i className="bx bx-envelope"></i>
              <h3>Email Me</h3>
              <a href="mailto:heyawshad@gmail.com"><p>heyawshad@gmail.com</p></a>
            </div>
          </div>

          <div className="col-md-6 mt-4 d-flex align-items-stretch">
            <div className="info-box">
              <i className="bx bx-phone-call"></i>
              <h3>Call Me</h3>
              <a href="tel:+94756800099"><p>+94 75 680 0099</p></a>
            </div>
          </div>
        </div>

        <form className="email-form mt-4" onSubmit={sendEmail}>
          <div className="row">
            <div className="col-md-6 form-group">
              <input type="text" name="name" className="form-control" id="name" placeholder="Your Name" required />
            </div>
            <div className="col-md-6 form-group mt-3 mt-md-0">
              <input type="email" className="form-control" name="email" id="email" placeholder="Your Email" required />
            </div>
          </div>
          <div className="form-group mt-3">
            <input type="text" className="form-control" name="subject" id="subject" placeholder="Subject" required />
          </div>
          <div className="form-group mt-3">
            <textarea className="form-control" name="message" rows="5" placeholder="Message" required></textarea>
          </div>
          <div className="my-3">
            <div className="text-center">
              {result === 'success' && <Success />}
              {result === 'error' && <Error />}
            </div>
          </div>
          <div className="text-center">
            <button type="submit">Send Message</button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default Contact;